// extracted by mini-css-extract-plugin
export default {"header-title-container":"HeaderTitle_header-title-container__aUqGi"};